import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Button, Form } from "react-bootstrap";
import getPracticeOnboardingStages from "../../utils/practiceOnboardingStages";
import isFileSizeUnderLimit from "../../utils/fileUploadSize";
import Spinner from 'react-bootstrap/Spinner';
import { Flag } from "react-feather";

const { REACT_APP_BACKEND_URL } = process.env;


const PracticeOnboardingDocuments = ({stage, token, data}) => {
  let practiceOnboardingStages = getPracticeOnboardingStages();

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        w9Filename: data.w9Filename == null ? "" : data.w9Filename,
        w9File: null,
        carrierListFilename: data.carrierListFilename == null ? "" : data.carrierListFilename,
        carrierListFile: null,
        locationListFilename: data.locationListFilename == null ? "" : data.locationListFilename,
        locationListFile: null
      }}
      validationSchema={Yup.object().shape({
        w9Filename: Yup.string(),
        w9File: Yup.mixed().when("w9Filename", {
          is: value => !value || value === "",
          then: Yup.mixed().required("W-9 is required"),
          otherwise: Yup.mixed()
        })
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        carrierListFilename: Yup.string(),
        carrierListFile: Yup.mixed()
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        ),
        locationListFilename: Yup.string(),
        locationListFile: Yup.mixed()
        .test(
          "fileSize",
          "File size too large; max file size is 10 Mb",
          isFileSizeUnderLimit
        )
      })}
      onSubmit={async (values, { setErrors, setStatus, resetForm, setSubmitting }) => {
        try {
          var formData = new FormData();

          if (values.w9File)
          {
            formData.append("w9File", values.w9File);
          }
          if (values.carrierListFile)
          {
            formData.append("carrierListFile", values.carrierListFile);
          }
          if (values.locationListFile)
          {
            formData.append("locationListFile", values.locationListFile);
          }
          
          const requestMetadata = {
            method: 'POST',
            body: formData
          };

          const res = await fetch(REACT_APP_BACKEND_URL + "practice-onboarding/" + stage + "/" + token, requestMetadata); 
          if (res.status >= 200 && res.status <= 299)
          {
            setStatus({success: true})

            window.location = "/practice-onboarding/success/" + token
          }
          else
          {
            throw Error(res.statusText);
          }
        } catch (error) {
          const message = "Something went wrong; please try again";

          setStatus({ success: false });
          alert(message);
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        status,
        touched,
        values,
        getFieldProps,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Documents</Form.Label>
            <br /><br />
            <Form.Label>W-9*</Form.Label>
            <br />
            {values.w9Filename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.w9Filename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("w9Filename")}
            />
            <Form.Control
              type="file"
              name="w9File"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("w9File", file);
              }}
              isInvalid={Boolean(touched.w9File && errors.w9File)}
            />
            {!!touched.w9File && (
              <Form.Control.Feedback type="invalid">
                {errors.w9File}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          <Form.Group>
            <Form.Label>Carrier List
            <br /><span style={{fontSize: '0.9em', fontWeight: "normal"}}><Flag style={{height: "16px", width: "16px", color: "#2B7A78"}} /> Spreadsheet or document containing a list of all contracted payors</span>
            </Form.Label>
            <br />
            {values.carrierListFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.carrierListFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("carrierListFilename")}
            />
            <Form.Control
              type="file"
              name="carrierListFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("carrierListFile", file);
              }}
              isInvalid={Boolean(touched.carrierListFile && errors.carrierListFile)}
            />
            {!!touched.carrierListFile && (
              <Form.Control.Feedback type="invalid">
                {errors.carrierListFile}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          <Form.Group>
            <Form.Label>Practice Location List
            <br /><span style={{fontSize: '0.9em', fontWeight: "normal"}}><Flag style={{height: "16px", width: "16px", color: "#2B7A78"}} /> Spreadsheet or document containing a list of all practice clinic locations</span>
            </Form.Label>
            <br />
            {values.locationListFilename && 
              <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.locationListFilename}</span>)</Form.Label>
            }
            <Form.Control
              type="hidden"
              {...getFieldProps("locationListFilename")}
            />
            <Form.Control
              type="file"
              name="locationListFile"
              onBlur={handleBlur}
              onChange={(event) => {
                const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                setFieldValue("locationListFile", file);
              }}
              isInvalid={Boolean(touched.locationListFile && errors.locationListFile)}
            />
            {!!touched.locationListFile && (
              <Form.Control.Feedback type="invalid">
                {errors.locationListFile}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <br /><br />
          
          {isSubmitting ?
          <div className="text-center">
             <br />
            <Spinner size="sm" animation="border" />
          </div>
          :
          <>
          <div className="text-center mt-3 float-start">
            <Button size="lg" className="btn-secondary" onClick={() => {window.location = "/practice-onboarding/" + practiceOnboardingStages[practiceOnboardingStages.indexOf(stage) - 1] + "/" + token}}>Back</Button>
          </div>
          <div id="submitButton" className="text-center mt-3 float-end">
            <Button
              type="submit"
              variant="primary"
              size="lg"
              disabled={isSubmitting}
            >
              Save and Complete
            </Button>
          </div>
          </>
          }
          <br /><br /><br />
          {
            Object.keys(errors).length > 0 && Object.keys(touched).length > 0 &&
            <div className="text-center mt-3"><span className="invalid-feedback" style={{display: "inline-block"}}>Please correct the errors above before completing the submission</span></div>
          }
        </Form>
      )}
    </Formik>
  );
}

export default PracticeOnboardingDocuments;
